/**
 * Deterministic hash of a Match List block ref. Two blocks with the same
 * effective inputs produce the same key so the fetcher dedupes their work
 * within a single request cycle.
 */
import type { Sport, MatchListMode } from "./sportRules";

export interface MatchListRef {
    sport: Sport;
    mode: MatchListMode;
    entityId?: string | null;
    competitionId?: string | null;
    competitionIds?: string[] | null;
    seasonId?: string | null;
    roundId?: string | null;
    fromDate?: string | null;
    toDate?: string | null;
    matchIds?: string[] | null;
    limit?: number | null;
    showOdds?: boolean | null;
    defaultMarket?: string | null;
}

function normList(v?: string[] | null): string[] {
    if (!v || v.length === 0) return [];
    return [...v].sort();
}

function normStr(v?: string | null): string | null {
    if (v == null) return null;
    const s = String(v).trim();
    return s.length === 0 ? null : s;
}

export function computeMatchListRefKey(ref: MatchListRef): string {
    const parts: Array<string | number | boolean | string[] | null> = [
        ref.sport,
        ref.mode,
        normStr(ref.entityId),
        normStr(ref.competitionId),
        normList(ref.competitionIds ?? undefined),
        normStr(ref.seasonId),
        normStr(ref.roundId),
        normStr(ref.fromDate),
        normStr(ref.toDate),
        normList(ref.matchIds ?? undefined),
        typeof ref.limit === "number" && Number.isFinite(ref.limit) ? ref.limit : null,
        ref.showOdds === true,
        normStr(ref.defaultMarket),
    ];
    return JSON.stringify(parts);
}
